import Routes from '@/lib/router/routes';

const signUpSteps = [
  Routes.SignUpRegister,
  Routes.SignUpIdentity,
  Routes.SignUpPersonalInformation,
  Routes.SignUpAreYouACompany,
  Routes.SignUpCompanyInformation,
  Routes.SignUpPersonalInformation,
  Routes.SignUpFavoriteIndustries,
  Routes.SignUpFinancialSituation,
  Routes.SignUpInvestmentKnowledgeQuestionnaire,
  Routes.SignUpInvestmentGoals, // Step 1
  Routes.SignUpInvestmentExperience, // Step 2
  Routes.SignUpStartupInvestmentExperience, // Step 2 bis
  Routes.SignUpRiskAwareness, // Step 3
  Routes.SignUpQuestionnaireResults,
  Routes.SignUpIdentityValidation,
  Routes.SignUpThankYou,
];

export const getPreviousSignUpStep = (pathname: string) => {
  const previousIndex = signUpSteps.findIndex((step) => step === pathname) - 1;

  if (previousIndex <= 0) {
    return Routes.Home;
  }

  return signUpSteps[previousIndex];
};
